import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link, useHistory } from "react-router-dom";
import { useDashboard } from "../contexts/DashboardContext";
import "../App.css";

const AddLicense = () => {
  let history = useHistory();
  let token = Cookies.get("token");
  const [id, setId] = useState("");
  const [type, setType] = useState("");
  const { customers, setCustomers, licenses, setLicenses } = useDashboard();
  let [credentials, setCredentials] = useState({
    type: "",
    count: "",
    customerid: "",
    expiry: null,
    isPerpetual: false,
  });
  let [error, setError] = useState("");

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { count, expiry } = credentials;
    axios
      .post(
        "/api/Customer/licenses",
        {
          type,
          count,
          customerid: id,
          expiry,
        },
        {
          headers: {
            "x-auth-token": token,
          },
        },
      )
      .then((res) => {
        setCredentials({
          type: "",
          count: "",
          customerid: "",
          expiry: null,
          isPerpetual: false,
        });
        history.push("/dashboard");
      })
      .catch(() => {
        setError("Invalid Data");
        setTimeout(() => {
          setError("");
        }, 1000);
      });
  };
  useEffect(() => {
    if (!token) {
      history.push("/");
    } else {
      axios
        .get("/api/customer", {
          headers: {
            "x-auth-token": token,
          },
        })
        .then((res) => {
          setCustomers(res.data.customers);
        })
        .catch(() => {
          history.push("/");
        });
    }
  }, []);

  useEffect(() => {
    if (!token) {
      history.push("/");
    } else {
      axios
        .get("/api/License", {
          headers: {
            "x-auth-token": token,
          },
        })
        .then((res) => {
          setLicenses(res.data.data);
        })
        .catch(() => {
          history.push("/dashboard");
        });
    }
  }, []);

  const handleSystemId = (e) => {
    e.preventDefault();
    setId(e.target.value);
  };

  const handleType = (e) => {
    e.preventDefault();
    setType(e.target.value);
  };

  return (
    <>
      <div className="container">
        <div className="addcustomer">
          <h2>Add License</h2>

          <form onSubmit={handleSubmit}>
            <select className="license" value={type} onChange={handleType}>
              <option value="">Select License</option>
              {licenses.map((license, i) => {
                return (
                  <option key={i} value={license.type}>
                    {license.name}
                  </option>
                );
              })}
            </select>
            <br />
            <input
              type="number"
              placeholder="Count"
              name="count"
              id="count"
              min="1"
              value={credentials.count}
              onChange={handleChange}
              required
            ></input>
            <br />
            <select className="license" value={id} onChange={handleSystemId}>
              <option value="">Select Customer</option>
              {customers.map((customer, i) => {
                return (
                  <option key={i} value={customer.value}>
                    {customer.label}
                  </option>
                );
              })}
            </select>
            <br />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                marginTop: "10px",
              }}
            >
              {/* Expiry Input */}
              <input
                type="text"
                placeholder="Expiry date"
                name="expiry"
                id="expiry"
                onFocus={(e) => {
                  if (!credentials.isPerpetual) {
                    e.currentTarget.type = "date";
                    e.currentTarget.min = new Date()
                      .toISOString()
                      .split("T")[0];
                  }
                }}
                value={credentials.expiry || ""}
                onChange={handleChange}
                disabled={credentials.isPerpetual}
                required={!credentials.isPerpetual}
                style={{
                  minWidth: "160px",
                  padding: "6px 12px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "0.95rem",
                  backgroundColor: credentials.isPerpetual ? "#e0e0e0" : "#fff", // greyish
                  color: credentials.isPerpetual ? "#555" : "#000",
                  cursor: credentials.isPerpetual ? "not-allowed" : "text",
                  transition: "background-color 0.2s, color 0.2s",
                }}
              />

              {/* Perpetual Toggle */}
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    width: "40px",
                    height: "22px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={credentials.isPerpetual}
                    onChange={(e) =>
                      setCredentials({
                        ...credentials,
                        isPerpetual: e.target.checked,
                        expiry: e.target.checked ? null : credentials.expiry,
                      })
                    }
                    style={{ opacity: 0, width: 0, height: 0 }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: credentials.isPerpetual
                        ? "#4caf50"
                        : "#ccc",
                      borderRadius: "22px",
                      transition: "0.4s",
                    }}
                  ></span>
                  <span
                    style={{
                      position: "absolute",
                      left: credentials.isPerpetual ? "18px" : "2px",
                      top: "2px",
                      width: "18px",
                      height: "18px",
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      transition: "0.4s",
                    }}
                  ></span>
                </div>
                Perpetual
              </label>
            </div>

            {error}
            <br />
            <br />
            <Link to="/dashboard">
              <button
                type="button"
                className="btn"
                style={{ float: "left", background: "grey", border: "grey" }}
              >
                Cancel
              </button>
            </Link>
            <button type="submit" className="btn" style={{ float: "right" }}>
              Add License
            </button>
            <br />
          </form>
        </div>
      </div>
    </>
  );
};

export default AddLicense;
